import React, { createContext } from "react";
import { ClientSort } from "../constants";
import { ALL_OPTIONS_TYPE } from "../wrappers/router/coach/CoachClientsWrapper";
import {
  CoachBriefInfoDto,
  TagDto,
} from "@growth-machine-llc/stridist-api-client";

interface CoachClientFiltersContextProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  sortKey: ClientSort;
  setSortKey: (sortKey: ClientSort) => void;
  filterTagIds: number[] | ALL_OPTIONS_TYPE;
  setFilterTagIdsChange: (
    tagIds?: number[],
    allOptionsSelected?: boolean,
  ) => void;
  tagList: TagDto[];
  coachList?: CoachBriefInfoDto[];
  setFilterCoachIdsChange?: (
    coachIds?: number[],
    allOptionsSelected?: boolean,
  ) => void;
  filterCoachIds?: number[] | ALL_OPTIONS_TYPE;
}

export const CoachClientFiltersContext =
  createContext<CoachClientFiltersContextProps | null>(null);
